const FaqCode = Object.freeze({
  
  CCTA_WHAT_IS: 1,
  CCTA_AGE: 2,
  CCTA_HOW_OFTEN: 3,
  CCTA_PRICE_COMPARISON: 4,
  CCTA_BETTER_TEST: 5,
  CCTA_LONGEVITY: 6,

  CAC_WHAT_IS: 7,
  CAC_EFFECTIVENESS: 8,
  CAC_FREQUENCY: 9,
  CAC_BLOOD_TESTING: 10,
  CAC_CCTA: 11,
  CAC_LONGEVITY: 12,

  ABOUT_US: 13,
  WHY_CHOOSE_INSTALAB: 14,
  WHAT_MAKES_INSTALAB_DIFFERENT: 15,
  WHAT_TESTS_SHOULD_I_BE_DOING: 16,
  HOW_DOES_INSTALAB_HELP: 17,
  POST_RESULTS: 18,
  HSA_FSA: 19,
  HEALTH_INSURANCE: 20,
  REPLACE_PCP: 21,
  REQUEST_TEST: 22,
  AREA_AVAILABILITY: 23,
  COMPANY_COVERAGE: 24,
  SECURITY: 25,
  GIFT: 26,

  APOB_HOW: 27,
  APOB_LDL: 28,
  APOB_FREQUENCY: 29,
  APOB_DIET: 30,
  APOB_LPA: 31,
  APOB_MEDICATION: 32,


  BIOBEAT_HOW_LONG: 33,
  BIOBEAT_VITAL_SIGNS: 34,
  BIOBEAT_BETTER_THAN_ARMCUFF: 35,
  BIOBEAT_WHO_SHOULD_USE: 36,
  BIOBEAT_HOW_IT_WORKS: 37,
  BIOBEAT_ACCURACY: 38,
  BIOBEAT_HOW_LONG_TO_GET_RESULTS: 39,
  BIOBEAT_WHERE_AVAILABLE: 40,
  BIOBEAT_HOW_TO_WEAR: 41,
  BIOBEAT_SETUP: 42,
  BIOBEAT_DOCTOR_REVIEW: 43,
  BIOBEAT_INSURANCE: 44,
  
  
})  

export default FaqCode